import { rangePresets } from '@gogame/intl-ts';

import {
  PLATFORMS,
  NETWORKS,
  APPLICATIONS,
  EXCLUDE_APPLICATIONS,
  DEVICES,
  OSVERSIONS,
} from './PopulationFieldSet/constants';

export const ACTIVITY = 'activity';
export const AUDIENCE_TYPES = 'audienceTypes';
export const DEPOSITORS = 'depositor';
export const SUBSCRIBERS = 'subscriber';
export const ENGAGEMENT_EVENTS = 'engagementEvents';

export const DEPENDENCIES = {
  [PLATFORMS]: [NETWORKS],
  [APPLICATIONS]: [NETWORKS, PLATFORMS, EXCLUDE_APPLICATIONS],
  [EXCLUDE_APPLICATIONS]: [NETWORKS, PLATFORMS, APPLICATIONS],
  [DEVICES]: [PLATFORMS],
  [OSVERSIONS]: [PLATFORMS],
};

export const PARTNER_AUDIENCES = 'partnerAudiences';

export const getAudienceFromValues = (values) => {
  /* eslint-disable-next-line */
  const { [PARTNER_AUDIENCES]: _, ...audience } = values;
  return audience;
};

export const getPartnerAudiencesFromValues = (values) => {
  const { [PARTNER_AUDIENCES]: partnerAudiences } = values;
  return partnerAudiences || [];
};

export const PERIOD_PRESETS = [
  rangePresets.TODAY,
  rangePresets.YESTERDAY,
  rangePresets.DAY_BEFORE_YESTERDAY,
  rangePresets.THIS_WEEK,
  rangePresets.THIS_MONTH,
  rangePresets.THIS_YEAR,
  rangePresets.LAST_7_DAYS,
  rangePresets.LAST_14_DAYS,
  rangePresets.LAST_30_DAYS,
  rangePresets.LAST_90_DAYS,
  rangePresets.LAST_180_DAYS,
  rangePresets.LAST_360_DAYS,
  rangePresets.LAST_730_DAYS,
  rangePresets.LAST_1095_DAYS,
  rangePresets.LAST_MONTH,
  rangePresets.LAST_2_MONTHS,
  rangePresets.LAST_3_MONTHS,
  rangePresets.LAST_YEAR,
  rangePresets.LIFETIME,
];
